<template>
    
    <div class="management">
        <div>
            <!-- Menu - Header -->
            <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <div class="input-group flex-nowrap w-100">
                        <button class="btn me-1 w-100" :class="{'btn-dark': section!='users', 'btn-kraken': section=='users'}" @click="section='users'" title="Users">
                            <i class="fa-solid fa-user-group"></i>
                        </button>
                        <button class="btn fs-5 me-1 w-100" :class="{'btn-dark': section!='policies', 'btn-kraken': section=='policies'}" @click="section='policies'" title="Policies">
                            <i class="fa-solid fa-file-shield"></i>
                        </button>
                        <button v-if="false" class="btn btn-primary w-100" :class="{'btn-dark': section!='settings', 'btn-kraken': section=='settings'}" @click="section='settings'" title="Settings">
                            <i class="fa-solid fa-gear"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Policies -->
            <div v-if="section=='policies'">
                <div class="row">
                    <input type="text" class="btn text-white fs-3 fw-bold" value="Policies" style="pointer-events: none; letter-spacing: 2px">
                </div>
                <div class="row">
                    <!-- Create -->
                    <div class="col-md-5">
                        <div class="bg-dark rounded p-2" :class="{'temporal-disable': creating_policy}">
                            <div class="input-group flex-nowrap">
                                <input type="text" class="btn text-white text-start fs-4 fw-bold" :value="'Create'" style="pointer-events: none; letter-spacing: 4px; width: 30%;">
                                <input type="text" class="btn bg-input text-white fs-5 fw-light rounded" v-model="policy.name" placeholder="Policy name" style="letter-spacing: 2px; width: 70%; cursor: text;">
                                <button v-if="false" class="btn rounded fs-5" :class="{'btn-primary': policy.human, 'btn-warning': !policy.human}" style="width: 10%;" @click="policyType" title="Policy type: Toggles between human and non-human types.">
                                    <i class="fa-solid fa-person" :class="{'fa-user': policy.human, 'fa-user-large-slash': !policy.human}"></i>
                                </button>
                            </div>
                            <!-- Length -->
                            <div class="input-group flex-nowrap mt-1">
                                <button class="btn btn-primary rounded me-1" style="width: 10%;" title="Length of the password." @click="policy.length.min = 15; policy.length.max = 30">
                                    <i class="fa-solid fa-arrows-left-right-to-line"></i>
                                </button>
                                <div class="input-group flex-nowrap" style="width: 90%;">
                                    <div class="rounded p-2 text-white bg-input" style="width: 100%;">
                                        Min. {{`(${policy.length.min})`}}
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.length.min" min="15" max="60" title="Minimum length." @change="protect('length_max')">
                                    </div>
                                    <div v-if="false" class="rounded p-2 text-white bg-input">
                                        Max. {{`(${policy.length.max})`}}
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.length.max" min="15" max="60" title="Maximum length." @change="protect('length_max')">
                                    </div>
                                </div>
                                <div v-if="false" class="rounded p-2 text-center text-white fs-4 bg-input" style="width:40%; pointer-events: none;">
                                    <div class="mt-5">
                                        Length: {{`${policy.length.min} - ${policy.length.max}`}}
                                    </div>
                                </div>
                            </div>
                            <!-- Letters -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-primary rounded me-1" style="width: 10%;" title="Letters." @click="policy.letters.lowercase_min = 1; policy.letters.uppercase_min = 1">
                                    <i class="fa-solid">Abc | | 123</i>
                                </button>
                                <div class="input-group flex-nowrap" style="width: 90%;">
                                    <div class="rounded p-2 text-white bg-input me-1" style="width: 33%;">
                                        <div title="Uppercase minimum.">ABC {{`(${policy.letters.uppercase_min})`}}</div>
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.letters.uppercase_min" min="1" max="50" title="Minimum uppercase letters.">
                                    </div>
                                    <div class="rounded p-2 text-white bg-input me-1" style="width: 33%;" >
                                        <div title="Lowercase minimum.">abc {{`(${policy.letters.lowercase_min})`}}</div>
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.letters.lowercase_min" min="1" max="50" title="Minimum lowercase letters.">
                                    </div>
                                    <div class="rounded p-2 text-white bg-input" style="width: 33%;" title="Lowercase minimum.">
                                        <div title="Numbers">123 {{`(${policy.numbers.min})`}}</div>
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.numbers.min" min="1" max="50" title="Minimum quantity of numbers.">
                                    </div>
                                </div>
                                <div v-if="false" class="rounded p-4 text-center text-white fs-5 bg-input" style="width:40%;">
                                    <div class="rounded p-2 text-white">
                                        123 {{`(${policy.numbers.min})`}}
                                        <input type="range" class="btn text-white w-100" v-model="policy.numbers.min" min="1" max="50" title="Minimum quantity of numbers.">
                                    </div>
                                </div>
                            </div>
                            <!-- Special Characters -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-primary rounded me-2" style="width: 10%;" title="Special characters." @click="policy.letters.lowercase_min = 1; policy.uppercase_min = 1">
                                    <i class="fa-solid fa-star"></i>
                                </button>
                                <div class="rounded p-2 text-center text-white rounded bg-input" style="width: 90%;">
                                    <div class="w-100">
                                        Special Characters {{`(${policy.special.min})`}}
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.special.min" min="1" max="50" title="Minimum special characters.">
                                    </div>
                                    <div class="input-group flex-nowrap">
                                        <div class="w-100">
                                            <button v-for="(sv, sk, si) in policy.spechars" :key="si" class="btn me-2 mt-1 fs-6" style="width: 12%;" :class="{'btn-primary': policy.spechars[sk], 'btn-dark': !policy.spechars[sk]}" @click="policy.spechars[sk] = !policy.spechars[sk]">
                                                <i class="fa-solid">{{special_icons[sk]}}</i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- General -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-primary rounded me-1" style="width: 10%; pointer-events: none;" title="General settings.">
                                    <i class="fa-solid fa-gears"></i>
                                </button>
                                <div class="input-group flex-nowrap" style="width: 90%;">
                                    <div class="rounded p-2 text-white bg-input me-1" style="width: 33%;">
                                        <div title="Days of inactivity." style="cursor: pointer;">
                                            <i class="fa-solid fa-calendar-days"></i> 
                                            {{`(${policy.general.inactivity})`}}
                                        </div>
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.general.inactivity" min="15" max="60" title="Days of inactivity.">
                                    </div>
                                    <div class="rounded p-2 text-white bg-input me-1" style="width: 33%;">
                                        <div title="Expiration." style="cursor: pointer;">
                                            <i class="fa-solid fa-hourglass-end"></i> 
                                            {{`(${policy.general.expiration})`}}
                                        </div>
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.general.expiration" min="15" max="180" title="Expiration.">
                                    </div>
                                    <div class="rounded p-2 text-white bg-input me-1" style="width: 33%;">
                                        <div title="Login tries." style="cursor: pointer;">
                                            <i class="fa-solid fa-arrows-spin"></i> 
                                            {{`(${policy.general.logintries})`}}
                                        </div>
                                        <input type="range" class="btn text-white w-100" v-model.number="policy.general.logintries" min="1" max="10" title="Login tries.">
                                    </div>
                                </div>
                            </div>
                            <!-- Save -->
                            <div class="mt-2">
                                <button class="btn btn-primary w-100 fs-5" @click="createPolicy">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- My Policies -->
                    <div class="col-md-7">
                        <div class="bg-dark rounded p-2" :class="{'temporal-disable': gettingPolicies}">
                            <div class="input-group flex-nowrap">
                                <input type="text" class="btn text-white text-start fs-4 fw-bold" :value="`My Policies (${policies.length})`" style="pointer-events: none; letter-spacing: 4px">
                                <div style="width: 60%;"></div>
                                <button class="btn bg-input fs-5 rounded" style="width: 10%;" @click="getPolicies">
                                    <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingPolicies}"></i>
                                </button>
                            </div>
                            <div class="input-group flex-nowrap mt-2">
                                <div class="btn btn-primary fw-bold fs-6 text-start border-0" style="width: 20%; margin-right: 2px;" title="Policy name">
                                    Policy Name
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px;" title="Minimun length">
                                    <i class="fa-solid fa-arrows-left-right-to-line"></i>
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px; " title="Lowercase letters">
                                    abc
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px; " title="Uppercase letters">
                                    ABC
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px; " title="Numbers">
                                    Numbers
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px; " title="Numbers of special characters">
                                    Special
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 20%; margin-right: 2px; " title="Valid special characters">
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px; " title="Expiration days">
                                    Expiration
                                </div>
                            </div>
                            <div class="" style="">
                                <div class="input-group flex-nowrap mt-1" v-for="(pv, pi) in policies" :key="pi">
                                    <div class="btn bg-input text-start fw-bold fs-6" style="width: 20%; margin-right: 2px; pointer-events: none;" title="Policy name">
                                        {{pv.name}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Minimun length">
                                        {{pv.length}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Lowercase letters">
                                        {{pv.lowercase_min}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Uppercase letters">
                                        {{pv.uppercase_min}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Numbers">
                                        {{pv.numbers}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Numbers of special characters">
                                        {{pv.special}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 20%; margin-right: 2px; pointer-events: none;" title="Valid special characters">
                                        {{pv.specials}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Expiration days">
                                        {{pv.expiration}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Users -->
            <div v-if="section=='users'">
                <div class="row">
                    <input type="text" class="btn text-white fs-3 fw-bold" value="Users" style="pointer-events: none; letter-spacing: 2px">
                    <!-- Actions -->
                    <div class="col-md-4" :class="{'temporal-disable':sendingInvitation || alteringUser}">
                        <div class="bg-dark rounded p-2">
                            <div class="input-group flex-nowrap">
                                <input type="text" class="btn text-white text-start fs-4 fw-bold" :value="'Actions'" style="pointer-events: none; letter-spacing: 4px; width: 50%;">
                                <select class="btn bg-input rounded fs-6 text-start" style="width: 50%" v-model="action.mode" @change="setActionEnv()">
                                    <option value="new">New User</option>
                                    <option value="reset">Reset Password</option>
                                    <option value="chgroup">Change Group</option>
                                </select>
                            </div>
                            <!-- New User -->
                            <div v-if="action.mode=='new'">
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn btn-primary rounded" style="width: 10%; pointer-events: none;" tabindex="-1" title="Username">
                                        <i class="fa-solid fa-user"></i>
                                    </button>
                                    <input type="text" class="btn bg-input me-1" style="cursor: text; width: 45%;" placeholder="First Name(s)" v-model="action.firstname">
                                    <input type="text" class="btn bg-input" style="cursor: text; width: 45%;" placeholder="Last Name(s)" v-model="action.lastname">
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn btn-primary rounded" style="width: 10%; pointer-events: none;" tabindex="-1" title="Username">
                                        <i class="fa-solid fa-id-card"></i>
                                    </button>
                                    <input type="text" class="btn bg-input" style="cursor: text; width: 90%;" placeholder="Username" v-model="action.username">
                                </div>
                            </div>
                            <!-- New / Change Group -->
                            <div v-if="['reset','chgroup'].includes(action.mode)">
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn btn-primary rounded" style="width: 10%; pointer-events: none;" tabindex="-1" title="Username">
                                        <i class="fa-solid fa-users"></i>
                                    </button>
                                    <select class="btn bg-input" style="width: 90%;" v-model="action.user" @change="setActionEnv(false);">
                                        <option :value="null">Select user...</option>
                                        <option :value="user" v-for="(user, usi) in users" :key="usi">{{user.username}}</option>
                                    </select>
                                </div>
                            </div>
                            <!-- Common -->
                            <!-- Name -->
                            <div v-if="['reset','chgroup'].includes(action.mode)" class="input-group flex-nowrap mt-1">
                                <button class="btn btn-primary rounded" style="width: 10%; pointer-events: none;" tabindex="-1" title="Name">
                                    <i class="fa-solid fa-user"></i>
                                </button>
                                <input type="text" class="btn bg-input" style="cursor: text; width: 90%; pointer-events:none;" placeholder="Name" :value="action.user != null ? action.user.name:'...'" readonly>
                            </div>
                            <!-- Email -->
                            <div class="input-group flex-nowrap mt-1">
                                <button class="btn btn-primary rounded" style="width: 10%; pointer-events: none;" tabindex="-1" title="Email">
                                    <i class="fa-solid fa-at"></i>
                                </button>
                                <input v-if="action.mode == 'new'" type="text" class="btn bg-input" style="cursor: text; width: 90%;" placeholder="Email" v-model="action.email">
                                <input v-if="action.mode != 'new'" type="text" class="btn bg-input" style="cursor: text; width: 90%; pointer-events: none;" placeholder="Email" :value="action.user != null ? action.user.email:'...'">
                            </div>
                            <!-- Group -->
                            <div v-if="['chgroup'].includes(action.mode) & false" class="input-group flex-nowrap mt-1">
                                <button class="btn btn-primary rounded" style="width: 10%;" tabindex="-1" title="Current Group">
                                    <i class="fa-solid fa-users-viewfinder" :class="{'fa-fade text-black': gettingGroups}"></i>
                                </button>
                                <input type="text" class="btn bg-input" style="cursor: text; width: 90%; pointer-events: none;" placeholder="Name" :value="action.user != null ? action.user.gname:'...'" readonly>
                            </div>
                            <div v-if="['new','chgroup'].includes(action.mode)" class="input-group flex-nowrap mt-1">
                                <button class="btn btn-info rounded" style="width: 10%;" tabindex="-1" @click="getGroups" title="Group">
                                    <i class="fa-solid fa-users-viewfinder" :class="{'fa-fade text-black': gettingGroups}"></i>
                                </button>
                                <select class="btn bg-input" style="width: 90%;" v-model="action.group">
                                    <option :value="null">Select group.</option>
                                    <option :value="g.group_id" v-for="(g, gi) in groups" :key="gi">{{g.group_name}}</option>
                                </select>
                            </div>
                            <!-- Policy -->
                            <div v-if="['new'].includes(action.mode)" class="input-group flex-nowrap mt-1">
                                <button class="btn btn-primary rounded" style="width: 10%; pointer-events: none;" tabindex="-1" title="Policy">
                                    <i class="fa-solid fa-user-shield"></i>
                                </button>
                                <select class="btn bg-input" style="width: 90%;" title="Policy to assign." v-model="action.policy">
                                    <option :value="null">Select policy.</option>
                                    <option :value="p.uid" v-for="(p, pi) in policies" :key="pi">{{p.name}}</option>
                                </select>
                            </div>
                            <!-- Triggers -->
                            <div v-if="action.mode=='new'" class="mt-1">
                                <button class="btn btn-primary w-100" @click="sendInvitation">
                                    <i class="fa-solid" :class="{'fa-paper-plane':!sendingInvitation, 'fa-refresh fa-spin': sendingInvitation}"></i>
                                </button>
                            </div>
                            <div v-if="action.mode=='reset'" class="mt-1">
                                <button class="btn btn-primary w-100" @click="sendInvitation" title="Reset password" :disabled="action.user == null">
                                    <i class="fa-solid" :class="{'fa-arrow-rotate-left':!sendingInvitation, 'fa-refresh fa-spin': sendingInvitation}"></i>
                                </button>
                            </div>
                            <div v-if="action.mode=='chgroup'" class="mt-1">
                                <button class="btn btn-primary w-100" @click="alterUser" title="Change group" :disabled="action.group == null">
                                    <i class="fa-solid fa-arrow-rotate-right" :class="{'fa-spin': alteringUser}"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <!-- My users -->
                    <div class="col-md-8">
                        <div class="bg-dark rounded p-2" :class="{'temporal-disable': gettingUsers || deleting_user}">
                            <div class="input-group flex-nowrap">
                                <input type="text" class="btn text-white text-start fs-4 fw-bold" :value="`Users (${users.length})`" style="pointer-events: none; letter-spacing: 4px">
                                <div style="width: 60%;"></div>
                                <button class="btn bg-input fs-5 rounded" style="width: 10%;" @click="getUsers">
                                    <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingUsers}"></i>
                                </button>
                            </div>
                            <div class="input-group flex-nowrap mt-2">
                                <div class="btn btn-primary fw-bold fs-6 text-start border-0" style="width: 30%; margin-right: 2px;" title="Name">
                                    Name
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px;" title="Username">
                                    <i class="fa-solid fa-id-card"></i>
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 25%; margin-right: 2px;" title="Email">
                                    <i class="fa-solid fa-at"></i>
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 25%; margin-right: 2px;" title="Status">
                                    <i class="fa-solid fa-info"></i>
                                </div>
                                <div class="btn btn-primary fw-bold fs-6 border-0" style="width: 10%; margin-right: 2px;" title="Status">
                                    <i class="fa-solid fa-trash"></i>
                                </div>
                            </div>
                            <div class="" style="">
                                <div class="input-group flex-nowrap mt-1" v-for="(us, usi) in users" :key="usi">
                                    <div class="btn bg-input text-start fw-bold fs-6" style="width: 30%; margin-right: 2px; pointer-events: none;" title="Name">
                                        {{us.name}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px; pointer-events: none;" title="Username">
                                        {{us.username}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 25%; margin-right: 2px; pointer-events: none;" title="Email">
                                        {{us.email}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 25%; margin-right: 2px; pointer-events: none;" title="Status">
                                        {{us.status}}
                                    </div>
                                    <div class="btn bg-input fw-bold fs-6" style="width: 10%; margin-right: 2px;" title="Status">
                                        <button class="btn btn-danger text-white" @click="deleteUser(us)">
                                            <i class="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <!-- Settings -->
            <div v-if="section=='settings'">
                <input type="text" class="btn text-white fs-3 fw-bold" value="Settings" style="pointer-events: none; letter-spacing: 2px">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                        <div class="bg-dark p-2 w-100 rounded">
                            <div class="input-group flex-nowrap">
                                <button class="btn text-white fs-5" style="pointer-events: none;">
                                    <i class="fa-solid fa-person-circle-xmark"></i>
                                </button>
                                <input type="text" class="btn text-white text-start fs-5 fw-bold" :value="`Days of Inactivity: ${settings.inactivity_time}`" style="pointer-events: none; letter-spacing: 2px" title="After this period of inactivity (not login registered), the user access will be blocked.">
                            </div>
                            <div class="text-start">
                                <input type="range" class="btn w-100" min="1" max="60" v-model="settings.inactivity_time">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                        <button class="fs-5 btn btn-primary w-100">
                            <i class="fa-solid fa-save"></i>
                        </button>
                    </div>
                </div>
            </div>


        </div>


    </div>

</template>


<script>

import axios from "axios";

export default {
  name: 'Management',
  components: {},
  data(){
    return {
        site: null,
        stage: null,
        section: 'users',
        // Section : Policies
        gettingPolicies: false,
        policy: {
            name: null,
            alias: null,
            //human: true,
            length:  { min: 15, max: 30 },
            letters:   { lowercase_min: 1,  uppercase_min: 1  },
            numbers: {min: 1},
            special: { min: 1,  max: null, },
            spechars: {
                excl: false,
                hashtag: false,
                money: false,
                perc: false,
                amper: false,
                slash: false,
                oppar: false,
                clopar: false,
                equal: false,
                dot: false,
                cloque: false,
                at: false,
                minus: false,
                plus: false
            },
            general: {
                inactivity: 30,
                expiration: 60,
                logintries: 3
            }
        },
        default_policy: null,
        policies: [],
        creating_policy: false,
        special_icons: {
            excl: '!',
            hashtag: '#',
            money: '$',
            perc: '%',
            amper: '&',
            slash: '/',
            oppar: '(',
            clopar: ')',
            equal: '=',
            dot: '.',
            cloque: '?',
            at: '@',
            minus: '-',
            plus: '+'
        },
        cp_page: 1, // Create Policy page.
        // Section : Users
        gettingUsers: false,
        users: [],
        sendingInvitation: false,
        default_action: null,
        action: {
            mode: 'new',
            firstname: null,
            lastname:  null,
            username:  null,
            email: null,
            group: null,
            policy: null,
            user: null
        },
        groups: [],
        gettingGroups: false,
        alteringUser: false,
        deleting_user: false,
        // Section : Settings
        settings: {
            inactivity_time: 30
        },
    }
  },
  methods:{
    protect(action){
        if (action == 'length_max'){
            if (this.policy.length.min > this.policy.length.max){
                this.policy.length.max = this.policy.length.min
            }
        }
    },
    // Policies
    getPolicies(){
        this.gettingPolicies = true
        const dest = this.site + '/panoptico/management/getPolicies'
        axios
            .get(dest)
            .then(rx => {
                this.policies = rx.data
                this.gettingPolicies = false
                //console.log("policies", JSON.stringify(this.policies))
            })
            .catch(error => {
                this.gettingPolicies = false
            });
    },
    createPolicy(){
        if (!this.policy.name){
            alert('Invalid policy name.')
            return
        }
        this.creating_policy = true
        const dest = this.site + '/panoptico/management/createPolicy'
        axios
            .post(dest, {policy: this.policy})
            .then(rx => {
                this.policy = this.cloneObject(this.default_policy)
                this.creating_policy = false
                if (rx.data.data.message == 'OK'){
                    alert('Policy successfully created.')
                    this.getPolicies()
                }
            })
            .catch(error => {
                this.creating_policy = false
                alert(`${error.response.data.data.error}.`)
            });
    },
    policyType(){
        if(this.policy.human){
            alert('Setting policy type as Non-Human.')
            this.policy.human = false
        }
        else{
            alert('Setting policy type as human.')
            this.policy.human = true
        }
        
    },
    // Users
    getUsers(){
        this.gettingUsers = true
        const dest = this.site + '/panoptico/management/getUsers'
        axios
            .get(dest)
            .then(rx => {
                this.users = rx.data.data
                this.gettingUsers= false
            })
            .catch(error => {
                this.gettingUsers = false
            });
    },
    getGroups(){
        this.gettingGroups = true
        const dest = this.site + '/panoptico/management/getGroups'
        axios
            .get(dest)
            .then(rx => {
                this.groups = rx.data.data[0].groups
                this.gettingGroups = false
            })
            .catch(error => {
                this.gettingGroups = false
            });
    },
    sendInvitation(){
        // Reset: mode , username & email
        this.sendingInvitation = true
        const dest = this.site + '/panoptico/management/sendInvitation'
        if (this.action.mode == 'reset'){
            this.action.username = this.action.user.username
            this.action.email = this.action.user.email
        }
        axios
            .post(dest, {action: this.action})
            .then(rx => {
                if (rx.data.data.message == 'OK'){
                    if (this.action.mode == 'new'){
                        alert(`Invitation sent successfully, the user "${this.action.username}" has to verify his identity.`)
                    }
                    else if (this.action.mode == 'reset'){
                        alert(`Password reseted, the user "${this.action.username}" has to verify his identity.`)
                    }
                    //else if (this.action.mode == 'chgroup'){
                    //    alert(`Group changed for the user "${this.action.username}".`)
                    //}
                    //this.getUsers()

                }
                this.sendingInvitation = false
                this.action = this.cloneObject(this.default_action)
            })
            .catch(error => {
                alert(`${error.response.data.data.error}.`)
                this.sendingInvitation = false
            }); 
    },
    alterUser(){
        if(this.action.group == this.action.user.group){
            alert('The user is already in the selected group, choose a different group.')
            return
        }
        this.alteringUser = true
        const dest = this.site + '/panoptico/management/changeGroup'
        const params = {
            mode: 'chgroup',
            user: this.action.user.username,
            secret: null,
            confirmation: null,
            group: this.action.group
        }
        axios
            .post(dest, {params})
            .then(rx => {
                alert(rx.data.data.message)
                this.action = this.cloneObject(this.default_action)
                this.action.mode = 'chgroup'
                this.alteringUser = false
            })
            .catch(error => {
                this.alteringUser = false
                alert(`${error.response.data.data.error}.`)
            }); 
    },
    deleteUser(user){
        if (!confirm('Delete user?')){
            return
        }
        this.deleting_user = true
        const dest = this.site + '/panoptico/management/deleteUser'
        const params = {
            id: user.panoptico_id
        }
        axios
            .post(dest, {params})
            .then(rx => {
                alert(rx.data.data.message)
                this.deleting_user = false
                this.getUsers()
            })
            .catch(error => {
                alert(`${error.response.data.data.errorMessage}.`)
                this.deleting_user = false
            }); 
    },
    //
    setActionEnv(clean=true){
        var mode = this.action.mode
        if (clean){
            this.action = this.cloneObject( this.default_action )
            this.action.mode = mode
        }
        // Reset
        //if (mode == 'reset'){
        //    this.action
        //}
        // Change group
        if (mode == 'chgroup'){
            if (this.action.user != null){
                this.action.group = this.action.user.group
            }
            else{
                this.action.group = null
            }
        }
    },


    // Misc
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },

  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.default_policy = this.cloneObject( this.policy )
    this.default_action = this.cloneObject( this.action )
    this.getGroups()
    this.getPolicies()
    this.getUsers()
  }
}
</script>


<style scoped>

    .bg-input{
        background-color: rgb(7,13,15);
        color: white;
    }

    .temporal-disable{
        opacity: 0.5;
        pointer-events: none;
    }


    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 211, 249);
    }
    
    .vertical-range{
        writing-mode: vertical-lr;
        direction: rtl;
        appearance: slider-vertical;
        width: 16px;
        vertical-align: bottom;
    }

</style>